import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";

import { auth, db } from "../Firebase";
import { toast } from "react-toastify";
import "../styles/Signup.css";

const Signup = () => {
  const [fullName, setFullName] = useState(""); // NEW
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  /* ================= USERNAME GENERATOR ================= */
  const generateUsername = (email, name = "") => {
    let base = name || email.split("@")[0];

    base = base
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");

    const random = Math.floor(1000 + Math.random() * 9000);
    return `${base}${random}`;
  };

  /* ================= EMAIL SIGNUP ================= */
  const handleEmailSignup = async () => {
    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }

    try {
      const userCredential =
        await createUserWithEmailAndPassword(auth, email, password);

      const user = userCredential.user;
      const username = generateUsername(user.email, fullName);

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        name: fullName,
        username: username,
        certificateName: fullName,

        email: user.email,
        biography: "",
        language: "",
        phone: "",
        occupation: "",
        education: "",
        college: "",
        country: "",
        state: "",
        city: "",
        website: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        x: "",
        youtube: "",

        role: "",
        profileImage: "",
        provider: "password",
        isVerified: user.emailVerified,
        createdAt: serverTimestamp(),
        lastLoginAt: serverTimestamp()
      });

      toast.success("Registration complete, login now");
      navigate("/login");
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  /* ================= GOOGLE SIGNUP ================= */
  const handleGoogleSignup = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        const username = generateUsername(
          user.email,
          user.displayName
        );

        await setDoc(userRef, {
          uid: user.uid,
          name: user.displayName || "",
          username: username,
          certificateName: user.displayName || "",

          email: user.email,
          biography: "",
          language: "",
          phone: user.phoneNumber || "",
          occupation: "",
          education: "",
          college: "",
          country: "",
          state: "",
          city: "",
          website: "",
          facebook: "",
          instagram: "",
          linkedin: "",
          x: "",
          youtube: "",

          role: "student",
          profileImage: user.photoURL || "",
          provider: "google",
          isVerified: user.emailVerified,
          createdAt: serverTimestamp(),
          lastLoginAt: serverTimestamp()
        });
      }

      navigate("/course");
    } catch (error) {
      console.error(error);
      toast.error("Google signup failed");
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">
        <h1>Sign up and start learning</h1>

        <button className="btn-google" onClick={handleGoogleSignup}>
          Sign up with Google
        </button>

        <button className="btn-facebook" disabled>
          Sign up with Facebook
        </button>

        <div className="signup-divider">
          <span>or</span>
        </div>

        {/* NEW FIELD */}
        <label>Full Name</label>
        <input
          type="text"
          placeholder="Enter your full name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />

        <label>Email</label>
        <input
          type="email"
          placeholder="example@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label>Password</label>
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="eye"
            onClick={() => setShowPassword(!showPassword)}
          >
            👁
          </span>
        </div>

        <button className="btn-primary" onClick={handleEmailSignup}>
          Create Account
        </button>

        <p className="login-text">
          Already on Vidify?{" "}
          <span onClick={() => navigate("/login")}>Log in</span>
        </p>
      </div>
    </div>
  );
};

export default Signup;
